import React, { Component } from "react";
import * as actionTypes from "../../../store/Actions/actions";
import { connect } from "react-redux";
class FormFieldsModal extends Component {
  constructor(props) {
    super(props);
    this.state = { id: null, editFields: false, editIndex: null };
  }

  render() {
    return (
      <div>
        <div onClick={this.props.hideEdit} className="overlayEdit"></div>

        <div className="inputFieldsModal">
          <h3 className="header">
            {this.props.InputText}
            <span className="closeModalIcon" onClick={this.props.hideEdit}>
              <svg width="17.9" height="17.901" viewBox="0 0 17.9 17.901">
                <path
                  id="fa-times"
                  d="M7.04,5.781,5.781,7.04l7.691,7.691L5.781,22.423,7.04,23.682l7.691-7.691,7.691,7.691,1.259-1.259-7.691-7.691L23.682,7.04,22.423,5.781l-7.691,7.691Z"
                  transform="translate(-5.781 -5.781)"
                  fill="#fff"
                />
              </svg>
            </span>
          </h3>
          {this.props.children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    layout: state.present.layout,
    preset: state.present.preset,
    layoutTitle: state.present.layoutTitle
  };
};
const mapDispatchToProps = dispatch => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      )
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FormFieldsModal);
